import React from "react";
import { View, Text, Pressable, StyleSheet } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { glueStyles } from "../configGlueStack/gluestack-ui.config";

export interface WorkflowStepsProps {
  steps: {
    step0_name?: string;
    steps: Array<{
      name?: string;
      member?: string;
    }>;
  };
  currentStep: number;
  currentStateOnly: boolean;
  itemPayload: any;
  onStepPress: (memberValue: any) => void;
}

export const WorkflowSteps = React.memo(({
  steps,
  currentStep,
  currentStateOnly,
  itemPayload,
  onStepPress,
}: WorkflowStepsProps) => {
  // La lógica de concat y nombres se puede simplificar
  const allSteps = React.useMemo(() => [{ name: steps.step0_name || "Inicio" }].concat(steps.steps), [steps]);

  return (
    <View style={styles.stepsContainer}>
      {allSteps.map((step, idx) => {
        const isCurrentStep = currentStep === idx;
        const isPastStep = currentStep > idx;
        if (currentStateOnly && !isCurrentStep) return null;

        // Evita el split/slice pesado si no es necesario en el render
        return (
          <Pressable 
            key={`step-${idx}`} 
            onPress={() => onStepPress(itemPayload.get(step.member)?.value)}
          >
            <View style={styles.stepWrapper}>
              {!currentStateOnly && (
                <Ionicons name="arrow-forward" size={12} color={glueStyles.colors.light400} style={styles.stepArrow} />
              )}
              <View style={[
                styles.stepBadge,
                isCurrentStep ? styles.stepCurrent : (isPastStep ? styles.stepSuccess : styles.stepPending)
              ]}>
                <Text style={[styles.stepText, isCurrentStep && styles.stepTextActive]}>
                  {step.name || idx + 1}
                </Text>
              </View>
            </View>
          </Pressable>
        );
      })}
    </View>
  );
});

WorkflowSteps.displayName = "WorkflowSteps";

const styles = StyleSheet.create({
  stepsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: 4,
    maxWidth: "60%"
  },
  stepWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 2,
    marginBottom: 2,
  },
  stepArrow: {
    marginHorizontal: 2,
  },
  stepBadge: {
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 2,
  },
  stepCurrent: {
    backgroundColor: glueStyles.colors.danger500,
  },
  stepSuccess: {
    backgroundColor: glueStyles.colors.success100,
  },
  stepPending: {
    backgroundColor: glueStyles.colors.yellow200,
  },
  stepText: {
    fontSize: 10,
    color: '#666',
  },
  stepTextActive: {
    fontWeight: 'bold',
    color: '#fff',
  },
});
